module.exports = ":host {\n  display: block;\n  position: relative; }\n"